import { AssignmentListView, AttachDialogView, TenantDefaultsView } from '@today/ui-domain'
import { useContentT } from '@/hooks/content/useContentQueries'
import { useTenantDefaults } from '@/hooks/content/useTenantDefaults'

/** `/content/tenant-defaults` — the tenant-scope assignments (TO-420 content-admin-ui REQ-012). */
export function TenantDefaultsPage() {
	const { t } = useContentT()
	const defaults = useTenantDefaults()
	return (
		<>
			<TenantDefaultsView t={t} list={<AssignmentListView {...defaults.list} />} onAttach={defaults.onAttach} />
			<AttachDialogView {...defaults.attach} />
		</>
	)
}
